// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingActions.js" company="Izenda">  
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var compose = require('recompose').compose;
  var pure = require('recompose').pure;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;

  var DatabaseMappingStore = require('logic/Izenda.DatabaseMappingStore');

  var databaseMappingActions = compose(
    pure,
    withProps(function () {
      return {
        store: new DatabaseMappingStore()
      };
    }),
    withHandlers({
      initial: initial,
      destroy: destroy
    })
  );

  /**
   * Initial store.
   */
  function initial() {
    return function (props) {
      var loader = props.loader;
      var store = props.store;

      loader.startLoading();
      return store.init()
        .finally(loader.endLoading.bind(loader));
    };
  }

  /**
   * Handle before leave page.
   */
  function destroy() {
    return function (store) {
      store.destroy();
    };
  }

  module.exports = databaseMappingActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/Izenda.DatabaseMappingActions.js